import type { ReactNode } from "react";

type Tone = "default" | "primary" | "success" | "warning" | "danger" | "accent";

export function Badge({
  children,
  tone = "default",
  title,
}: {
  children: ReactNode;
  tone?: Tone;
  title?: string;
}) {
  const toneClass = tone === "default" ? "" : `badge--${tone}`;
  return (
    <span className={`badge ${toneClass}`.trim()} title={title}>
      {children}
    </span>
  );
}
